import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';
import {
  IOneToOneTutorRateStudentType,
  IOneToOneTutorRateStudentTypeDeleteVerificationData,
} from '.';

export type TAdminCreateOneToOneTutorRateStudentType = {
  name: string;
  grades: Array<{ curriculum: string; grade: string }>;
};

export type TAdminGetOneToOneTutorRateStudentTypes = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateOneToOneTutorRateStudentType = {
  id: string;
  name: string;
  grades: Array<{ curriculum: string; grade: string }>;
};

const apiDataProvider = new APIDataProvider();

const adminGetOneToOneTutorRateStudentTypesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetOneToOneTutorRateStudentTypes) => {
  let path = `${AdminApiPaths.oneToOneTutorRateStudentTypes}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${encodeURIComponent(searchText)}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IOneToOneTutorRateStudentType>>
  >(path);

  return response.data;
};

export const adminCreateOneToOneTutorRateStudentType = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-student-types/create',
  async (data: TAdminCreateOneToOneTutorRateStudentType) => {
    const path = `${AdminApiPaths.oneToOneTutorRateStudentTypes}`;

    const response = await apiDataProvider.post<
      TApiResponse<IOneToOneTutorRateStudentType>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateOneToOneTutorRateStudentType = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-student-types/update',
  async (data: TAdminUpdateOneToOneTutorRateStudentType) => {
    const path = `${AdminApiPaths.oneToOneTutorRateStudentTypes}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IOneToOneTutorRateStudentType>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteOneToOneTutorRateStudentType = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-student-types/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.oneToOneTutorRateStudentTypes}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IOneToOneTutorRateStudentType>
    >(path);

    return response.data;
  }
);

export const adminVerifyOneToOneTutorRateStudentTypeDelete = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-student-types/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.oneToOneTutorRateStudentTypes}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IOneToOneTutorRateStudentTypeDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetOneToOneTutorRateStudentTypes = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-student-types/list',
  adminGetOneToOneTutorRateStudentTypesModule
);

export const adminGetOneToOneTutorRateStudentTypesForDropdown = createAsyncThunk(
  '/admin/one-to-one-tutor-rate-student-types/dropdown-list',
  adminGetOneToOneTutorRateStudentTypesModule
);
